import React, {useState} from "react";
import ReactFlow, {
    removeElements,
    addEdge,
    MiniMap,
    Controls,
    Background, useStoreState,
} from 'react-flow-renderer';
import {Button, Col, Form, Input, Modal, Row, Select} from "antd";
import {stepConnection, stepOption} from "../stores/fixed/BuildInVocs";
import {PatientQuerySimpleEditor} from "../components/Forms/Parts/PatientQuerySimpleEditor";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";

const NodeEditor = ({item, visible, hide}) => {
    const [form] = Form.useForm();

    const onFormChange = (data) => {

        console.log("x", data)
        //frm.data = data
    }

    return <Modal width={1000} visible={visible} onOk={hide} onCancel={hide} title={"Редактор целевых групп"}>
        <Form
            onValuesChange={onFormChange}
            initialValues={item}>
            <Form.Item name={"title"} label={"Название"}>
                <Input></Input>
            </Form.Item>
            <Form.Item name={"type"} label={"Тип"} >
                <Select>
                    <Select.Option value={1} title={"Постоянная группа"}>Постоянная группа</Select.Option>
                    <Select.Option value={2} title={"Временная группа"}>Временная группа</Select.Option>
                </Select>
            </Form.Item>
            <Form.Item label="Пациенты">
                <span className="ant-form-text">Группа пациентов для включения в целевую группу</span>
            </Form.Item>
            <Form.List
                name="names"
            >

                {(fields, { add, remove }, { errors }) => (
                    <>
                        {fields.map((field, index) => (
                            <Form.Item>
                                <Row gutter={5}>
                                    <Col  span={22}>
                                        <PatientQuerySimpleEditor/>
                                    </Col>
                                    <Col span={2}>
                                        <MinusCircleOutlined
                                            className="dynamic-delete-button"
                                            onClick={() => remove(field.name)}/>
                                    </Col>
                                </Row>
                            </Form.Item>
                        ))}
                        <Form.Item>
                            <Button
                                type="dashed"
                                onClick={() => add()}
                                style={{ width: '100%' }}
                                icon={<PlusOutlined />}
                            >
                                Добавить группу
                            </Button>
                            <Form.ErrorList errors={errors} />
                        </Form.Item>
                    </>
                )}
            </Form.List>


        </Form>
    </Modal>
}

const ViewNode = ({item}) =>
{
    const [visible, setVisible] = useState()
    const hide = () => setVisible(false)
    return (<>
        <div><div onClick={() => setVisible(true)}>{item.title}</div></div>
        <NodeEditor item={item} visible={visible} hide={hide}/>
</>)}

const initialElements = [...stepOption.map( (item, idx, array) => ({
        id: item.value,
        type: item.type,
        data: {label: <ViewNode item={item}/>},
        isNode: true,
        position: {
            x: ((450 * item.col) || 900) - 225 , y: Number(item.level)*100},
    })
), ...stepConnection.map(item => ({
    ...item,
    id: "e" + item.source + '-' + item.target,
    animated: true,
}))]


const onLoad = (reactFlowInstance) => {
    console.log('flow loaded:', reactFlowInstance);
    reactFlowInstance.fitView();
};

const OverviewFlow = () => {
    const [elements, setElements] = useState(initialElements);

    const onElementsRemove = (elementsToRemove) =>
        setElements((els) => removeElements(elementsToRemove, els));
    const onConnect = (params) => setElements((els) => addEdge(params, els));

    return (
        <ReactFlow
            elements={elements}
            onElementsRemove={onElementsRemove}
            onConnect={onConnect}
            onLoad={onLoad}
            snapToGrid={true}
            snapGrid={[15, 15]}
            defaultZoom={0.4}
            style={{margin: 20}}
        >

            <MiniMap
                nodeStrokeColor={(n) => {
                    if (n.style?.background) return n.style.background;
                    if (n.type === 'input') return '#0041d0';
                    if (n.type === 'output') return '#ff0072';
                    if (n.type === 'default') return '#1a192b';

                    return '#eee';
                }}
                nodeColor={(n) => {
                    if (n.style?.background) return n.style.background;

                    return '#fff';
                }}
                nodeBorderRadius={2}
            />
            <Controls />
            <Background color="#aaa" gap={16} />
        </ReactFlow>
    );
};



const TriggerEditorPage = () => {
    const [visible, setVisible] = useState(false)
    return (<div>
        <Row style={{width: "100%"}}>
            <Col span={20}>Триггерные точки: управление маршрутом                  </Col>
            <Col span={4}>
                <Button style={{float: 'right', margins: 16}} type="primary" onClick={() => setVisible(true)}>Добавить</Button>
                <Button style={{float: 'right', margins: 16}}>Импорт</Button>
                <Button style={{float: 'right', margins: 16}}>Экспорт</Button>
            </Col>
        </Row>



        <Row style={{height: 1000, margin: 50}}><OverviewFlow/></Row>
        <NodeEditor item={{}} visible={visible} hide={() => setVisible(false)}/>

</div>)}

export default TriggerEditorPage